import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { appointmentDraftActions, journeyStateActions } from '~/api';
import { isEmpty } from '~/utils';
import {
  setEditMode,
  saveTemporaryAppointment,
  saveTemporaryJourneyState,
} from '../../edit-appointment.actions';
import {
  ShopsSearchForm,
  SearchFormContext,
  errorTypes,
  Messages,
  withRestorableDraft,
  withRequiredPrecondition,
  withProgressBar,
  warningModalSelectors,
} from '~/components';

import { EditButtonsWrapper } from '../../components';
import { formatToTemporaryState } from '../../helpers';
import {
  getTokenFromStorage,
  setTokenToStorage,
  TEMPORARY_TOKEN_NAME,
} from '../../../../../components/persist-token/persist-token.utils';

const { NO_SHOP_SEARCH_MADE_ERROR } = errorTypes;

export class EditShop extends PureComponent {
  state = {
    context: {
      searchFormTitle: 'Appointment details',
      searchFormInlineErrorMsg: 'Please enter a valid shop name, town or postcode',
      isSearchTermInvalid: false,
    },
  };

  componentDidMount() {
    this.setTemporaryAppointment();
    window.scrollTo(0, 0);
  }

  setTemporaryAppointment = () => {
    const {
      draft,
      journeyState,
      temporaryAppointment,
      temporaryJourneyState,
      dispatchSaveTemporaryAppointment,
      dispatchSaveTemporaryJourneyState,
    } = this.props;
    if (isEmpty(temporaryAppointment)) {
      dispatchSaveTemporaryAppointment(formatToTemporaryState(draft));
      setTokenToStorage(getTokenFromStorage(), TEMPORARY_TOKEN_NAME);
    }
    if (isEmpty(temporaryJourneyState)) {
      dispatchSaveTemporaryJourneyState(journeyState);
      setTokenToStorage(getTokenFromStorage(), TEMPORARY_TOKEN_NAME);
    }
  };

  onShopsLoadedHandler = () => {
    this.setState((prevState) => ({
      context: {
        ...prevState.context,
        isSearchTermInvalid: false,
      },
    }));
  };

  render() {
    const {
      temporaryAppointment,
      temporaryJourneyState,
      history,
      location,
      showWarningModal,
      draft,
      journeyState,
      dispatchSetEditMode,
      dispatchSetDraftAppointment,
      dispatchSaveTemporaryAppointment,
      dispatchSetJourneyState,
      dispatchSaveTemporaryJourneyState,
    } = this.props;
    const { context } = this.state;

    return (
      <SearchFormContext.Provider value={context}>
        <ShopsSearchForm onShopsLoadedHandler={this.onShopsLoadedHandler} messages={Messages}>
          <Messages forTypes={[NO_SHOP_SEARCH_MADE_ERROR]} />
        </ShopsSearchForm>
        <EditButtonsWrapper
          displayButtons
          temporaryDraftAppointment={temporaryAppointment}
          history={history}
          location={location}
          showWarningModal={showWarningModal}
          bookingId={draft.id}
          state={formatToTemporaryState(draft)}
          journeyState={journeyState}
          setEditMode={dispatchSetEditMode}
          temporaryJourneyState={temporaryJourneyState}
          restoreAppointmentDraft={dispatchSetDraftAppointment}
          restoreJourneyState={dispatchSetJourneyState}
          saveTemporaryState={dispatchSaveTemporaryAppointment}
          saveTemporaryJourneyState={dispatchSaveTemporaryJourneyState}
          hideSaveButton
        />
      </SearchFormContext.Provider>
    );
  }
}

export const mapStateToProps = (state) => {
  const {
    appointment: { draft },
    editAppointment: { temporaryAppointment, temporaryJourneyState },
    journeyState,
    router: { location },
  } = state;

  const warningModalState = warningModalSelectors.selectState(state);
  return {
    location,
    draft,
    journeyState,
    temporaryAppointment,
    temporaryJourneyState,
    showWarningModal: !!warningModalState.isOpen,
  };
};

const mapDispatchToProps = {
  dispatchUpdateAppointmentType: appointmentDraftActions.updateAppointmentType,
  dispatchSetEditMode: setEditMode,
  dispatchSaveTemporaryAppointment: saveTemporaryAppointment,
  dispatchSetDraftAppointment: appointmentDraftActions.setDraftAppointment,
  dispatchSaveShop: appointmentDraftActions.saveAppointmentDraft,
  dispatchSetJourneyState: journeyStateActions.setJourneyState,
  dispatchSaveTemporaryJourneyState: saveTemporaryJourneyState,
};

export const ConnectedEditShop = withRestorableDraft(
  withRequiredPrecondition(connect(mapStateToProps, mapDispatchToProps)(withProgressBar(EditShop))),
);

export const ConnectedEditShopForManageAppointment = connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditShop);

EditShop.propTypes = {
  history: PropTypes.shape({}).isRequired,
  location: PropTypes.shape({}).isRequired,
  draft: PropTypes.shape({
    shop: PropTypes.shape({}).isRequired,
    id: PropTypes.string,
  }).isRequired,
  temporaryAppointment: PropTypes.shape({}).isRequired,
  temporaryJourneyState: PropTypes.shape({}).isRequired,
  journeyState: PropTypes.shape({}).isRequired,
  showWarningModal: PropTypes.bool.isRequired,

  dispatchSetEditMode: PropTypes.func.isRequired,
  dispatchSaveTemporaryAppointment: PropTypes.func.isRequired,
  dispatchSetDraftAppointment: PropTypes.func.isRequired,
  dispatchSetJourneyState: PropTypes.func.isRequired,
  dispatchSaveTemporaryJourneyState: PropTypes.func.isRequired,
};
